import type { YogiQLFlag } from 'features/feedback/previews-request'
import {
  type FeatureFlagsResponse,
  useFeatureFlags,
} from 'features/project/feature-flags'

// The backend's ENHANCED_DIALECT_FLAG; an existing hub flag, default off.
const ENHANCED_DIALECT_FLAG = 'enhanced_dialect'

/** The hub's `enhanced_dialect` flag, read where the page wires its hooks. */
export function useEnhancedDialectFlag(): YogiQLFlag {
  const { data: flags, isLoading } = useFeatureFlags()
  return {
    enabled:
      (flags as FeatureFlagsResponse | undefined)?.[ENHANCED_DIALECT_FLAG] ===
      true,
    settled: !isLoading,
  }
}
